<template><div></div></template>
<script>
export default {
  name: 'GoogleMapCuadrillaMarker',
  props: {
    loader: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    },
    google: {
      type: Object,
      required: true
    }
  },

  mounted() {
    const marker = this.marker
    this.loader.importLibrary('marker').then(({ Marker }) => {
      const mark = new Marker({
        position: { lat: parseFloat(this.marker.rast_lat), lng: parseFloat(this.marker.rast_lng) },
        map: this.map,
       })
      var infoWindow = new this.google.InfoWindow({
        content: `<div><div>Cuadrilla: ${this.marker.cuad_descripcion}</div><div>Fecha: ${this.marker.rast_fecha}</div></div>`
      })
      // Agregar un evento de clic al marcador para mostrar la ventana de información
      mark.addListener('click', function() {
        infoWindow.open({ map: this.map, anchor: mark })
      })
    }).catch(error => {
      console.log('Marker load error:', error)
    })
  },

  methods: {
    showMoreDetails() {
      console.log('showMoreDetails Marker')
    }
  }
}
</script>
<style scoped>
.marca {
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 50%;
  color: #263238;
  display: flex;
  font-size: 14px;
  gap: 15px;
  height: 30px;
  justify-content: center;
  padding: 4px;
  position: relative;
  position: relative;
  transition: all 0.3s ease-out;
  width: 30px;
}
</style>
